import { PiAsset } from "../Types/PiAsset";

export const GetAssetService = async () => {
    const apiUrl = process.env.REACT_APP_API_URL;

    try {
        const response = await fetch(`${apiUrl}/teams/assetstree/remapped`);

        const data = await response.json() as PiAsset;
        return data;

    } catch (error) {
        console.error("Failed to fetch data", error);
        return { Name: "", Capabilities: [{}], Children: [{}], Guid: "" } as PiAsset;
    }
}
